import {getRandomNumber} from "../../util/utils";

export interface IWishState {
    items: IWishesResponse,
    fetchWishesLoading: boolean
    details: IWish
    detailsLoading: boolean
    imagesLoading: boolean
    images: IWishImage[]
    actionLoading: boolean
    pastWinners: IWish[]
    activeProfileWishes: IMyWishes
    finishedProfileWishes: IMyWishes
    profileWishesLoading: boolean
    selectedRulebook: IWishRulebook
    rulebookLoading: boolean
    citiesWithCounts: ICitiesResponse[]
    citiesWithCountsLoading: boolean
    lastWishUpdateChange: string
}

export interface IWishesResponse {
    total_pages: number
    count: number
    data: IWish[]
}

export interface IWishLocation {
    lat: number
    lng: number
}

export interface IWish {
    start_time: string
    end_time: string
    name_en: string
    name_mk: string
    name_al: string
    description_en: string
    description_mk: string
    description_al: string
    company: string
    company_url: string | null
    cost: number
    max_tickets: number
    original_cost: number | null
    created_at: string
    id: string
    additional_information_en: string[] | null
    additional_information_mk: string[] | null
    additional_information_al: string[] | null

    [key: string]: any

    tickets_count: number
    status: WishStatus
    thumbnail: string
    categories: IWishCategory[]
    points_award: number | null
    winner: IWinnerTicket | null
    recommended: boolean
    client_id: string | null
    voucher_expiry: string | null
    type: WishType
    city: string
    locations?: IWishLocation[]
    parent_wish_id?: string
    children?: IWish[]
    option_name_en?: string
    option_name_mk?: string
    option_name_al?: string
}

export interface IWinnerTicket {
    redeemed_at: string | null
    ticket: {
        id: string
        code: string
        recipient_name: string | null
        recipient_email: string | null
        user: {
            email: string
            full_name: string
            profile_picture: string
        }
    }

}

export interface IWishImage {
    id: string
    url: string
    wish_id: string
}

export enum WishStatus {
    PENDING = "PENDING",
    ACTIVE = "ACTIVE",
    FINISHED = "FINISHED",
    TERMINATED = "TERMINATED"
}

export enum WishType {
    VOUCHER = "voucher",
    DRAW = "draw"
}

export enum WishSortOptions {
    CREATED_AT = "created_at",
    END_TIME = "end_time",
    TICKETS_COUNT = "tickets_count",
    COST = "cost",
}

interface IWishCategory {
    id: string
    name_en: string
    name_mk: string
    name_al: string
}

interface ILoadingError {
    loading: boolean
    error: boolean
}

export const initialWishesState: IWishesResponse = {
    total_pages: 0,
    count: 0,
    data: []
}

export const initialWishDetailsState: IWish = {
    categories: [],
    company: "",
    company_url: null,
    created_at: "",
    description_en: "",
    description_mk: "",
    description_al: "",
    id: "",
    additional_information_en: null,
    additional_information_mk: null,
    additional_information_al: null,
    cost: 0,
    max_tickets: 0,
    original_cost: null,
    name_en: "",
    name_mk: "",
    name_al: "",
    status: WishStatus.PENDING,
    start_time: "",
    end_time: "",
    thumbnail: "",
    tickets_count: 0,
    points_award: 0,
    winner: null,
    recommended: false,
    client_id: null,
    voucher_expiry: null,
    type: WishType.VOUCHER,
    city: "Skopje"
}

export const initialLoadingErrorState: ILoadingError = {
    error: false,
    loading: false
}

export const getRandomWishImagesArray = (): IWishImage[] => {
    const arr: IWishImage[] = []
    const numElements = getRandomNumber(1, 4)
    for (let i = 0; i < numElements; i++) {
        arr.push(
            {
                id: 'random', url: '', wish_id: ""
            }
        )
    }

    return arr
}

export const getRandomWishesArray = (): IWish[] => {
    const arr: IWish[] = []
    const numElements = getRandomNumber(3, 6)
    for (let i = 0; i < numElements; i++) {
        arr.push(
            {...initialWishDetailsState, id: i.toString()}
        )
    }

    return arr
}

export interface IMyProfileCategories {
    id: string
    name_en: string
    name_mk: string
    name_al: string

    [key: string]: any
}

export interface IProfileWish extends IWish {
    quantity: number
}

export interface IMyWishes {
    count: number
    data: IProfileWish[]
}

export const initialMyWishesState: IMyWishes = {
    count: 0,
    data: []
}

export interface IWishRulebook {
    id: string
    doc_url: string
    wish_id: string
}

export const initialWishRulebookState: IWishRulebook = {
    id: "",
    doc_url: "",
    wish_id: "",
}

export interface ICitiesResponse {
    id: string
    city: string
    count: number
}

export const getRandomCitiesArray = (): ICitiesResponse[] => {
    const arr: ICitiesResponse[] = []
    const numElements = getRandomNumber(5, 9)
    for (let i = 0; i < numElements; i++) {
        arr.push(
            {
                id: i.toString(), count: 0, city: ""
            }
        )
    }

    return arr
}